export const defaultConfig = {
    MIN_DICTATION_SESSION_DURATION_SECONDS: 30,
    MAX_DICTATION_SESSION_DURATION_SECONDS: 1200,
    INACTIVITY_SIGN_OUT_MINUTES: 15,
    INACTIVITY_WARNING_MINUTES: 10,
};
